export enum LearningBehaviorType{
        Attention = 1,
        ConductBehaviour = 2,
        Hyperactivity = 3,
        Learning = 4,
        MentalHealth = 5,
        SpeechLanguage = 6
}